import { useMemo } from 'react';

import { usePlatformService } from 'core/Hooks';
import { Outlet, useLocation, useOutletContext } from 'react-router-dom';
import { AppShell } from 'ui';

import { MainHeader } from '../../../components/Header/MainHeader';
import { useNavbar } from '../../../hooks/useNavbar';

type StandardLayoutContext = {
  search: any;
  isDesktop: boolean;
  setSearch: () => void;
  handleClose: () => void;
  handleOpen: () => void;
};

export function useStandardLayout() {
  return useOutletContext<StandardLayoutContext>();
}

// @acdodd17 Maybe I'd start with how a drawer feels for the mobile pop out thing
export const StandardLayout = () => {
  const location = useLocation();
  const { state }: { state: any } = location;
  const { search, setSearch, handleClose, handleOpen } = useNavbar();
  const backgroundLocation = useMemo(() => state?.backgroundLocation || false, [state]);

  const Platform = usePlatformService();
  const nativeHeaderHeight = `calc(max(45px, env(safe-area-inset-top)) + 60px)`;
  // we only want to use native header calc if platform is native; otherwise set responsive heights
  const headerHeight = Platform.isNative ? nativeHeaderHeight : { base: 64, sm: 72 };

  return (
    <AppShell
      padding={{ base: 'sm', sm: 'lg' }}
      // hidden={Boolean(hideForCause) || Boolean(hideForReferrals)}
      header={{ height: headerHeight }}
    >
      <MainHeader />

      <AppShell.Main>
        <Outlet
          context={{
            overlay: backgroundLocation,
            search,
            setSearch,
            handleClose,
            handleOpen,
          }}
        />
      </AppShell.Main>
    </AppShell>
  );
};
